import React from 'react';
import styled from 'styled-components';

import CarStatus, { Name as CarStatusName } from '@/components/CarStatus';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';

function Status() {
  const data = useTypedSelector(selectDetailedCarData);

  if (!data || !data.stockStatus) {
    return null;
  }

  return (
    <Component>
      <CarStatus carStatus={data.stockStatus.id} />
    </Component>
  );
}

export default Status;

const Component = styled.div`
  margin-top: 10px;

  ${CarStatusName} {
    color: ${(props) => props.theme.black};
  }
`;
